import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";

declare global {
  interface Window {
    gtag: (command: string, action: string, params?: Record<string, any>) => void;
  }
}

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isUpdating, setIsUpdating] = useState(true);

  useEffect(() => {
    const updateBookingStatus = async () => {
      const cartId = searchParams.get('cartId') || searchParams.get('id') || searchParams.get('token');
      
      if (cartId) {
        try {
          // Call edge function to update status securely
          await supabase.functions.invoke('update-payment-status', {
            body: { paymentId: cartId, status: 'successful' }
          });
        } catch {
          // Silent failure - booking status update is non-critical for UX
        }
      }
      setIsUpdating(false);
    };

    updateBookingStatus();

    // Google Ads conversion tracking
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-17436644984/FiX_CN3azZ8bEPisuPpA',
        'value': 1.0,
        'currency': 'AED'
      });
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-secondary/20 p-4">
      <div className="bg-card rounded-lg shadow-2xl p-8 max-w-md w-full text-center">
        <div className="mb-6 flex justify-center">
          <CheckCircle className="w-20 h-20 text-green-500" />
        </div>
        
        <h1 className="text-3xl font-bold mb-4 text-foreground">
          {isUpdating ? "Processing..." : "Payment Successful!"}
        </h1>
        
        <p className="text-muted-foreground mb-8">
          Thank you for your booking. Your payment has been processed successfully.
          You will receive a confirmation email shortly.
        </p>

        <Button
          onClick={() => navigate("/")}
          className="w-full bg-primary hover:bg-primary/90"
        >
          Return to Home
        </Button>
      </div>
    </div>
  );
};

export default PaymentSuccess;
